import { useEffect } from "react";

const SITE_URL = "https://contre-epreuve.fr";
const DEFAULT_OG_IMAGE = `${SITE_URL}/brand/contre-epreuve-og-default-1200x630.png`;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content ?? "");
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Gestionnaire SEO / Open Graph / JSON-LD (sans dépendance).
export function useSEO({ title, description, image, type = "website", noindex = false, jsonLd } = {}) {
  useEffect(() => {
    const full = title
      ? `${title} · Contre-épreuve`
      : "Faits, sources et zones de doute · Contre-épreuve";
    document.title = full;

    const url = SITE_URL + window.location.pathname;
    const img = image || DEFAULT_OG_IMAGE;

    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    setLink("canonical", url);

    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", noindex ? "noindex, follow" : "index, follow");

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      script.setAttribute("data-seo-jsonld", "true");
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, image, type, noindex, jsonLd]);
}
